import { Duration, PurchasableProduct } from '@accedo/one-plugin-sdk';
import { FC } from 'react';

import {
  PlanPickerGrid,
  PlanPickerMainText,
  PlanPickerSubText,
} from '#/plugins/paywall/components';
import { FormattedPrice } from '#/plugins/paywall/FormattedPrice';
import { translatePrice } from '#/plugins/paywall/utils';
import { tb } from '#/store/translation/translation.store';

import { PriceText, ReceiptButton } from './PurchaseProductStep.styled';

type Props = PurchasableProduct & {
  isDisabled?: boolean;
  onProductChange: () => void;
  duration?: Duration;
};

export const SelectedProduct: FC<Props> = ({
  title,
  price,
  currency,
  duration,
  isDisabled,
  onProductChange,
}) => {
  const translatedPrice = translatePrice(price, currency, duration);

  return (
    <PlanPickerGrid>
      <div>
        <PlanPickerMainText>{title}</PlanPickerMainText>
        <PlanPickerSubText>
          <FormattedPrice
            AmountComponent={PriceText}
            translatedPrice={translatedPrice}
          />
        </PlanPickerSubText>
      </div>
      <ReceiptButton
        data-testid="selected-product-receipt-button"
        disabled={isDisabled}
        onClick={onProductChange}
      >
        {tb('iap.selectedPlan.changePlan')}
      </ReceiptButton>
    </PlanPickerGrid>
  );
};
